import { GET } from '@/request/index'
import URL from '@/request/api/url'

export const fetchNewList = (data) => {
  return GET(URL.NEWS_LIST, { data })
}
export const fetcTopNewList = (data) => {
  return GET(URL.NEWS_LIST2, { data })
}
